import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { initStateMemberData } from "mocks/memberData";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { base64ToBlob } from "utils/HelperFunction";
import { allowedFields, jsonKeys, mappingPes, mapProductToRequestItem } from "utils/HelperPesFunction";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { getHQAddressByDate } from "../../redux/handlers/logic/getHQAddressByDate.handler";
import { nanoid } from "@reduxjs/toolkit";
import { getPesById } from "../../redux/slices/logic/getPesById.slice";
import { useGlobalDocModalContext } from "contexts/GlobalDocModalContext";
import { isShowBranch, mappingSearchMember } from "utils/HelperMemberFunction";
import { clearUpdatePes, updatePes } from "../../redux/slices/logic/updatePes.slice";
import { clearCreatePes, createPes } from "../../redux/slices/logic/createPes.slice";
import { initStateDoData } from "mocks/doData";
import { getUserInfo } from "../../redux/handlers/auth/getUserInfo.handler";
import { genPesDocNumber } from "../../redux/slices/logic/genPesDocNumber.slice";
export default function usePesForm(param) {
    var setModalSuccess = param.setModalSuccess, setModalNotApprove = param.setModalNotApprove, setModalConfirmCancel = param.setModalConfirmCancel, setTab = param.setTab, setProductRow = param.setProductRow, setDocSeletecteds = param.setDocSeletecteds, columnsort = param.columnsort, setColumnsort = param.setColumnsort, setTagSelected = param.setTagSelected;
    var pesID = useParams().pesID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setModalNotiDocAlert = useGlobalDocModalContext().setModalNotiDocAlert;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var schema = yup.object().shape();
    // Reducers
    var reducers = {
        createPes: useAppSelector(function(state) {
            return state.createPesReducer;
        }),
        updatePes: useAppSelector(function(state) {
            return state.updatePesReducer;
        }),
        getPesById: useAppSelector(function(state) {
            return state.getPesByIdReducer;
        }),
        genPesDocNumber: useAppSelector(function(state) {
            return state.genPesDocNumberReducer;
        })
    };
    var isFormPesLoading = useMemo(function() {
        return reducers.createPes.isFetching || reducers.updatePes.isFetching || reducers.genPesDocNumber.isFetching || reducers.getPesById.isFetching;
    }, [
        reducers.createPes.isFetching,
        reducers.updatePes.isFetching,
        reducers.genPesDocNumber.isFetching,
        reducers.getPesById.isFetching
    ]);
    var _useState = _sliced_to_array(useState(false), 2), formdisabled = _useState[0], setFormdisabled = _useState[1];
    var _useState1 = _sliced_to_array(useState(initStateDoData), 2), formdata = _useState1[0], setFormdata = _useState1[1];
    var _useState2 = _sliced_to_array(useState(initStateMemberData), 2), pdata = _useState2[0], setPdata = _useState2[1];
    var _useState3 = _sliced_to_array(useState("สร้างบันทึกซื้อสินค้า"), 2), headerName = _useState3[0], setheaderName = _useState3[1];
    var formatResult = function(item) {
        var mappingMember = mappingSearchMember(item);
        var isShowBranchMember = isShowBranch({
            custType: item.member_customer_type,
            isHQ: item.member_is_hq,
            branchNo: item.member_branch_no
        });
        return /*#__PURE__*/ _jsxs("div", {
            className: "",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        mappingMember.customerName,
                        isShowBranchMember ? " - (".concat(mappingMember.branchCode, ")") : ""
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "tc-5",
                    children: [
                        mappingMember.customerID ? mappingMember.customerID : "ไม่พบเลขผู้เสียภาษี",
                        " ",
                        "- ",
                        mappingMember.customerCode
                    ]
                })
            ]
        }, nanoid());
    };
    var getHQAddress = function(payload) {
        dispatch(getHQAddressByDate(payload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var getData = function() {
        var id = pesID;
        dispatch(getPesById({
            id: id,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    // Load resources
    var loadResources = useCallback(function() {
        dispatch(getUserInfo({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        if (!pesID) {
            dispatch(genPesDocNumber({
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        pesID
    ]);
    var handleMainSubmit = function(param) {
        var values = param.values;
        // console.log('values', values);
        var formdataPayload = new FormData();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                var value = values[key];
                if (value === undefined || value === null) return "continue";
                if (key === "doc_files" && Array.isArray(value)) {
                    value.forEach(function(file) {
                        if (file.docData) {
                            var blob = base64ToBlob(file.docData);
                            formdataPayload.append(key, blob, "".concat(file.docName));
                        }
                    });
                } else if (jsonKeys.includes(key)) {
                    formdataPayload.append(key, JSON.stringify(value));
                } else if (Array.isArray(value)) {
                    value.forEach(function(item) {
                        formdataPayload.append(key, item);
                    });
                } else {
                    formdataPayload.append(key, value);
                }
            };
            for(var _iterator = allowedFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // console.log(formdataPayload);
        var id = pesID;
        var payload = formdataPayload;
        if (!pesID) {
            dispatch(createPes({
                payload: payload,
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else {
            dispatch(updatePes({
                id: id,
                payload: payload,
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    var handlePreSubmit = function(param) {
        var productRow = param.productRow, setFieldValue = param.setFieldValue, handleSubmit = param.handleSubmit, values = param.values, attachments = param.attachments, tagselected = param.tagselected, setModalAlert = param.setModalAlert, setErrors = param.setErrors;
        var product = productRow.filter(function(prev) {
            return prev.productCode !== "";
        });
        if (product && product.length > 0) {
            var newItems = [];
            newItems = mapProductToRequestItem(product);
            schema.validate(_object_spread_props(_object_spread({}, values), {
                fact_new_pes_items: newItems,
                attachments: attachments,
                tagselected: tagselected
            }), {
                abortEarly: false
            }).then(function() {
                var itemField = "fact_new_pes_items";
                setFieldValue(itemField, newItems);
                setFieldValue("tag_peses", tagselected);
                handleSubmit();
            }).catch(function(err) {
                var _err_errors;
                var errorMessage = ((_err_errors = err.errors) === null || _err_errors === void 0 ? void 0 : _err_errors.join("\n")) || "Invalid data. Please check the form.";
                console.log(errorMessage);
                var formErrors = {};
                err.inner.forEach(function(e) {
                    if (e.path) formErrors[e.path] = e.message;
                });
                setErrors(formErrors);
            });
        } else {
            setModalAlert(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
        }
    };
    useEffect(function() {
        if (reducers.createPes.data && !reducers.createPes.isError) {
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            // setFormdisabled(true);
            dispatch(clearCreatePes());
            var createdData = reducers.createPes.data.data;
            var id = createdData && createdData.id ? createdData.id : null;
            if (id) {
                setModalNotiDocAlert(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        open: prev.extra.genDocNumber !== createdData.doc_number,
                        extra: {
                            genDocNumber: prev.extra.genDocNumber,
                            createdDocNumber: createdData.doc_number
                        }
                    });
                });
                navigate("/financial-accounting/peak-connection/pes/edit/".concat(id));
            } else {
                navigate("/financial-accounting/peak-connection/pes");
            }
        }
        if (reducers.updatePes.data && !reducers.updatePes.isError) {
            setModalConfirmCancel(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            setTab(1);
            dispatch(clearUpdatePes());
            getData();
        }
        if (reducers.getPesById.data && !reducers.getPesById.isError && pesID) {
            var pesData = reducers.getPesById.data.data;
            if (!pesData) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = mappingPes({
                pesData: pesData,
                setPdata: setPdata,
                setDocSeletecteds: setDocSeletecteds,
                setProductRow: setProductRow,
                setFormdisabled: setFormdisabled,
                columnsort: columnsort,
                setColumnsort: setColumnsort,
                setTagSelected: setTagSelected
            });
            // const endDate = dataWithReplacements.doc_issue_date;
            // getHQAddress({ end_date: endDate });
            setFormdata(dataWithReplacements);
        }
        if (reducers.genPesDocNumber.data && !pesID && reducers.genPesDocNumber.data.data !== formdata.doc_number) {
            setFormdata(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    doc_number: reducers.genPesDocNumber.data.data
                });
            });
            setModalNotiDocAlert(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    extra: {
                        genDocNumber: reducers.genPesDocNumber.data.data,
                        createdDocNumber: prev.extra.createdDocNumber
                    }
                });
            });
        }
    }, [
        reducers.createPes.data,
        reducers.updatePes.data,
        reducers.getPesById.data,
        reducers.genPesDocNumber.data,
        pesID
    ]);
    useEffect(function() {
        if (pesID) {
            getData();
            setheaderName("แก้ไขบันทึกซื้อสินค้า");
        } else {
            setFormdata(initStateDoData);
        }
    }, [
        pesID
    ]);
    // Auto-load
    useEffect(function() {
        loadResources();
    }, [
        loadResources
    ]);
    return {
        schema: schema,
        formdisabled: formdisabled,
        setFormdisabled: setFormdisabled,
        formdata: formdata,
        setFormdata: setFormdata,
        pdata: pdata,
        setPdata: setPdata,
        formatResult: formatResult,
        handleMainSubmit: handleMainSubmit,
        handlePreSubmit: handlePreSubmit,
        headerName: headerName,
        isFormPesLoading: isFormPesLoading
    };
}
